import { Init } from "@pdfking/reactivity/vue"
import { CreateSingleton } from "@pdfking/tfunc"
import {
  first,
  group_by,
  object_map,
  ordered_object,
  scan,
} from "@pdfking/rfunc"
import {
  Identity,
  KeyTake,
  Partial,
  RecordMerge,
  SortBy,
  Values,
  Zip,
} from "@pdfking/tfunc"
import get_django_url from "../utils/get_django_url"

const decompress = ({ keys, values }, processor = a => a) =>
  // @ts-expect-error TS2345
  object_map(first, c => processor(ordered_object(Zip(keys, c))), values)

const process_tag = tag => {
  tag.counter = 0
  return tag
}

const process_page = (tags, page) => {
  scan(t => (tags[t].counter += 1), page.tags)

  page.kind = tags[first(page.tags)]
  page.tags = KeyTake(tags, page.tags)

  page.kind_sequence = page.kind.sequence * 10000 + page.sequence

  return page
}

const public_autocomplete = [
  "regions",
  "public_pages",
  "switch",
  "imposition_preset",
  "standard_sizes",
] as const

export default CreateSingleton(() => Init({
  computed: RecordMerge(
    object_map(
      Identity,
      name =>
        function () {
          // @ts-expect-error TS2683
          this.load_autocomplete(name)
          // @ts-expect-error TS2683
          return this.autocomplete[name]
        },
      public_autocomplete
    ),
    {
      pages_by_url() {
        if (this.pages_index) {
          return object_map(
            (o: any) => o.url,
            (o: any) => o,
            this.pages_index
          )
        }
      },
      pages_descendants_by_url() {
        if (this.pages_index) {
          return group_by(
            Values(this.pages_index),
            p => {
              if (p.parent) {
                const res = this.pages_index[p.parent]
                if (res) {
                  return res.url
                }
              }
            },
            // @ts-expect-error TS2339
            objs => SortBy(objs, o => [o.kind_sequence, o.unicode])
          )
        }
      },
      pages_index() {
        // @ts-expect-error - Vue computed from object_map
        if (this.public_pages) {
          return decompress(
            // @ts-expect-error - Vue computed from object_map
            this.public_pages.objects.pages,
            Partial(process_page, this.tags_index)
          )
        }
      },
      tags_index() {
        // @ts-expect-error - Vue computed from object_map
        if (this.public_pages) {
          // @ts-expect-error - Vue computed from object_map
          return decompress(this.public_pages.objects.tags, process_tag)
        }
      },
    }
  ),
  data: {
    autocomplete: object_map(Identity, () => null, public_autocomplete),
    loading: object_map(Identity, () => null, public_autocomplete),
    promise: object_map(Identity, () => null, public_autocomplete),
  },
  methods: {
    load_autocomplete(name) {
      if (this.promise[name]) {
        return this.promise[name]
      }

      this.loading[name] = true
      this.promise[name] = get_django_url("autocomplete", {
        name,
      })
        .then(fetch)
        .then(r => r.json())
        .then(r => {
          this.autocomplete[name] = r
          this.loading[name] = false
          console.info(`finished autoloading for ${name}`)

          return this.autocomplete[name]
        })

      return this.promise[name]
    },
  },
}))
